import { render, staticRenderFns } from "./ContentDiscoveryListItem.vue?vue&type=template&id=1461001b&scoped=true&"
import script from "./ContentDiscoveryListItem.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryListItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentDiscoveryListItem.vue?vue&type=style&index=0&id=1461001b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461001b",
  null
  
)

export default component.exports